export const lt = (a: number, b: number): boolean => {
  return a - b <= -0.01;
};

export const gte = (a: number, b: number): boolean => {
  return a - b >= -0.01;
};

export const roundTo = (n: number, pos: number): number => {
  return Number(n.toFixed(pos));
};

export const getFractionalDigits = (n: number): number => (n % 1).toString().length;

export const widthToColumn = (width: string) => Math.round(parseInt(width) / 8.33);
